/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var browser = require('./browser');

exports.SetCookie = function (name, value) {
    var Days = 30; //此 cookie 将被保存 30 天
    var exp = new Date(); //new Date("December 31, 9998");
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
    document.cookie = 'muduapi_' + name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=/';
};
exports.GetCookie = function (name) {
    var arr = document.cookie.match(new RegExp('(^| )' + 'muduapi_' + name + '=([^;]*)(;|$)'));
    if (arr != null) return decodeURIComponent(arr[2]);return null;
};
exports.DelCookie = function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = exports.GetCookie(name);
    if (cval != null) document.cookie = 'muduapi_' + name + '=' + cval + ';expires=' + exp.toGMTString();
};

exports.GetRandomNum = function (Max, Min) {
    var Range = Max - Min;
    var Rand = Math.random();
    return Min + Math.round(Rand * Range);
};

exports.Guid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + s4() + s4() + s4();
};

exports.GetAbsoluteUrl = function (_ref) {
    var url = _ref.url,
        domain = _ref.domain,
        https = _ref.https,
        http = _ref.http;

    https = https || false;
    http = http || false;
    domain = domain || '';
    if (url.indexOf('//') === 0 || url.indexOf('http') === 0) {
        return url;
    }
    if (http) {
        return 'http://' + domain + url;
    }
    if (https) {
        return 'https://' + domain + url;
    }
    return '//' + domain + url;
};

exports.GetPrimarySocialLoginType = function (loginType) {
    var primarySocialLoginType = exports.GetSocialLoginTypeByEnvor();
    return primarySocialLoginType || loginType;
};

exports.GetSocialLoginTypeByEnvor = function () {
    if (browser.isWechat()) {
        return 'weixin';
    }
    if (browser.isQQ()) {
        return 'qq';
    }
    return 'weibo';
};

exports.addEventListener = function (dom, evt, cb) {
    if (window.addEventListener) {
        dom.addEventListener(evt, cb);
    } else if (window.attachEvent) {
        dom.attachEvent(evt, cb);
    }
};

exports.transformTimeStrToNumber = function (timeStr) {
    if ('number' === typeof timeStr) {
        return timeStr;
    } else if ('string' === typeof timeStr && timeStr.indexOf(':') !== -1) {
        return timeStr.split(':').reduce(function (sum, v, i) {
            return sum + +v * Math.pow(60, 2 - i);
        }, 0);
    }
    return 0;
};

exports.getPlayUrl = function (video) {
    var video1080p_url, video720p_url, video480p_url, video360p_url, video240p_url, videoOrigin_url;
    var play_set = video.play_set;
    play_set && play_set.length > 0 && play_set.forEach(function (item) {
        item.resolution === '1080P' && (video1080p_url = item.url);
        item.resolution === '720P' && (video720p_url = item.url);
        item.resolution === '480P' && (video480p_url = item.url);
        item.resolution === '360P' && (video360p_url = item.url);
        item.resolution === '240P' && (video240p_url = item.url);
        item.resolution.toLowerCase() === 'origin' && (videoOrigin_url = item.url);
    });
    return videoOrigin_url || video1080p_url || video720p_url || video480p_url || video360p_url || video240p_url || video.video_url || video.url;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/helper/utils.js
 ** module id = 14
 ** module chunks = 1
 **/